








import Vue, { PropType } from 'vue';
import SanityBlockContent from '@/components/SanityBlockContent.vue';
import SanitySimpleBlockContent from '@/models/sanitySchema/sanitySimpleBlockContent';

export default Vue.extend({
  name: 'SummaryPanel',
  components: {
    SanityBlockContent,
  },
  props: {
    content: {
      type: Array as PropType<Array<SanitySimpleBlockContent>>,
      required: true,
    },
  },
});
